<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="10">
            <h3>Locais</h3>
          </b-col>
          <b-col md="2">
            <b-button @click="navigate('/local/cadastrar')" block variant="primary">
              <i class="fa fa-plus"></i>
              <span>Novo Local</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="12">
            <b-form-group label="Local:">
              <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Local"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="perfilAdmin">
          <b-col sm="2">
            <b-form-group label="UF:">
              <b-form-select v-model="filtros.uf" :options="estados" class="mb-3">
                <option selected :value="null"> Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group label="Município:" :disabled="disabled_cidades">
              <b-form-select v-model="filtros.municipio" :options="cidades">
                <option selected :value="null"> Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <table aria-rowcount="4" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th v-if="perfilAdmin" scope="col">UF</th>
                    <th v-if="perfilAdmin" scope="col">Município</th>
                    <th scope="col">Local</th>
                    <th scope="col">Endereço</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="locais.data !== undefined">
                  <tr class="action" v-for="local in locais.data" :key="local.id">
                    <td v-if="perfilAdmin">{{ local.sigla }}</td>
                    <td v-if="perfilAdmin">{{ local.cidade }}</td>
                    <td>{{local.local}}</td>
                    <td>{{local.endereco}}</td>
                    <td style="width: 15%">
                      <a class="btn btn-sm btn-secondary action" title="Editar Local" @click="editarLocal(local.id)">
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a class="btn btn-sm btn-primary action" title="Excluir Local"
                        @click="modalConfirmaExclusao(local.id)">
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="8">Nenhum registro encontrado...</td>
                  </tr>
                </tbody>
              </table>
              <pagination v-show="locais.data !== undefined" :filtros="filtros" :totalPorPagina="totalPorPagina"
                :resource="resource"></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('buscarEstados')
      this.perfilAdmin = true
    }
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'P' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'L' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A') {
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
      this.$store.dispatch('buscarLocais')
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      disabled_cidades: true,
      perfilAdmin: false,
      modalPreExcluir: false,
      totalPorPagina: 20,
      totalSelectOp: [
        {text: '20', value: 20},
        {text: '30', value: 30},
        {text: '50', value: 50},
        {text: '100', value: 100}
      ],
      resource: 'local',
      filtros: {
        filter: '',
        sistema_id: null,
        status: null,
        uf: null,
        municipio: null
      }
    }
  },
  computed: {
    locais () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  watch: {
    'filtros.uf': function () {
      if (this.filtros.uf !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.filtros.uf)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
        this.filtros.municipio = null
      }
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        sistema_id: null,
        status: null,
        uf: null,
        municipio: null
      }
      this.pesquisar()
    },
    navigate (route) {
      this.$router.push(route)
    },
    editarLocal (id) {
      this.$router.push('/local/' + id + '/editar')
    },
    modalConfirmaExclusao (id) {
      this.$bvModal.msgBoxConfirm('Confirma a exclusão do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/local/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-check' })
              miniToastr.error(erro.body.msg, 'Alerta!', 12000)
              this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
            }
          })
        } else {
          this.modalPreExcluir = true
        }
      })
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}

td {
  max-width: 25ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/locais/Locais.vue